import { useUser, useInitialization } from '@izettle/react';
import { loadScript } from '../load-script.js';
import { UnsupportedBrowserStyles } from '../styles.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { shouldLoadWebComponent } from '../utils/rest.js';

const UnsupportedBrowser = _ref => {
  let {
    version = "latest"
  } = _ref;
  const userData = useUser();
  useInitialization(async () => {
    if (!shouldLoadWebComponent("iz-bo-unsupported-browser")) {
      return;
    }
    await loadScript(`https://cdn.izettle.com/components/unsupported-browser/${version}/unsupported-browser.${userData.locale.isoLocale}.min.js`);
  }, "");
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(UnsupportedBrowserStyles, {}), /*#__PURE__*/jsx("iz-bo-unsupported-browser", {})]
  });
};

export { UnsupportedBrowser };
//# sourceMappingURL=unsupported-browser.js.map
